
<div class="overlay" *ngIf="loading">
  <mat-progress-spinner
    mode="indeterminate"
    [diameter]="150"
    color="primary">
  </mat-progress-spinner>
</div>

<div class="watermark" *ngIf="env.DEMO != ''">{{env.DEMO}}</div>
<div class="demo-banner" *ngIf="env.DEMO != ''">
  <div class="scroll-text">
    ⚠️ {{env.DEMO}} - This environment is for demonstration purposes only. Data shown is not real and may be reset at any time.
  </div>
</div>

<ng-container *ngIf="!displayNotReadyPage">
    <div class="mb-5 d-flex justify-content-between" >
        <button mat-button class="addButton " (click)="emailReceipt()" *ngIf="displayEmail">
            <i class="pi pi-envelope" style="font-size: 0.9em; padding-left:5px; padding-right:5px"></i>
            Email
        </button>
        <button mat-button class="addButton " (click)="downloadPDF()" *ngIf="displayDownload">
            <i class="pi pi-download" style="font-size: 0.9em; padding-left:5px; padding-right:5px"></i>
            Download
        </button>
    </div>

    <div [innerHTML]="htmlContent">
        
    </div>
</ng-container>

<ng-container *ngIf="displayNotReadyPage">
    <div style="height:100%;display: flex;align-items: center;justify-content: center;
    font-family:'Inter';background-color:#fafafa;text-align: center;">
        <div>
            <!-- <h1 style="font-weight: bold;font-size:2rem;"><i class="pi pi-exclamation-triangle" style="font-size:2rem;"></i></h1> -->
            <p style="color:#0000008c;font-size:1.3rem;">{{message}}</p>
            <button mat-button class="addButton " (click)="refresh()" *ngIf="displayRefreshButton">
                <i class="pi pi-refresh" style="font-size: 0.9em; padding-left:5px; padding-right:5px"></i>
                Refresh
            </button>
        </div>
    </div>
</ng-container>

